import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import PropTypes from 'prop-types';

const CustomTooltip = (props) => {
//could pass children in as well to use this as a wrapper component rather than requiring props
  const [open, setOpen] = React.useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
        <Tooltip
          PopperProps={{
            disablePortal: true,
          }}
          onClose={handleTooltipClose}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title={props.title}
          arrow
          placement="bottom"
        >
          <div onClick={handleTooltipOpen} style={{display: 'flex'}}> {props.triggerComponent}{props.children}</div>
        </Tooltip>
    </ClickAwayListener>

  )
};

CustomTooltip.propTypes = {
  triggerComponent: PropTypes.object,
  title: PropTypes.node.isRequired,
  placement: PropTypes.string,
};

export default CustomTooltip;


